export type DistrictMapLegendItem = [number, number, string, string];

/** Fixed demand buckets on fraction scale `0–1` — same as legacy `DistrictsMapChartCard` on Demand. */
export const DEMAND_DISTRICT_MAP_LEGEND_ITEMS: DistrictMapLegendItem[] = [
    [0, 0.049, "<5%", "#FFEED4"],
    [0.05, 0.099, "5-10%", "#FFE298"],
    [0.1, 0.149, "10-15%", "#FFC56D"],
    [0.15, 0.199, "15-20%", "#FFA740"],
    [0.2, Infinity, ">20%", "#FF8800"]
];

export const dynamicDistrictMapLegendValues = (
    highestValue: number,
    legendType: "quantitative" | "pricing",
    colors: string[]
): DistrictMapLegendItem[] => {
    let legendItems: DistrictMapLegendItem[] = [];

    const formatLabelValueThousands = (value: number, maxValue: number): string => {
        if (value === Infinity) {
            return `${maxValue / 1000}k`;
        }

        return value >= 1000 ? `${value / 1000}k` : value.toString();
    };

    if (legendType === "quantitative") {
        const availableCeilings = [100, 200, 500, 1000, 2000];

        const percentages = [0.1, 0.2, 0.5, 1, 1];

        const lastCeiling = availableCeilings[availableCeilings.length - 1];

        for (let i = 0; i < availableCeilings.length; i++) {
            const ceiling = availableCeilings[i];
            if (highestValue <= ceiling || i === availableCeilings.length - 1) {
                legendItems = new Array(5).fill(null).map((_: null, n) => {
                    const minValue = n === 0 ? 0 : ceiling * percentages[n - 1];

                    const maxValue = n === colors.length - 1 ? Infinity : ceiling * percentages[n];

                    let label = "";

                    switch (n) {
                        case 0:
                            label = `<${formatLabelValueThousands(ceiling * percentages[n], lastCeiling)}`;
                            break;
                        case 1:
                        case 2:
                        case 3:
                            label = `${formatLabelValueThousands(minValue, lastCeiling)}-${formatLabelValueThousands(
                                maxValue,
                                lastCeiling
                            )}`;
                            break;
                        case 4:
                            label = `>${formatLabelValueThousands(minValue, lastCeiling)}`;
                            break;
                    }

                    return [minValue, maxValue, label, colors[n]];
                });

                break;
            }
        }
    }

    if (legendType === "pricing") {
        const availableCeilings = [10000, 15000, 20000];

        const ranges = [
            [5000, 7000, 9000, 10000, 10000],
            [7000, 9000, 12000, 15000, 15000],
            [7000, 10000, 15000, 20000, Infinity]
        ];

        const lastCeiling = availableCeilings[availableCeilings.length - 1];
        for (let i = 0; i < availableCeilings.length; i++) {
            const ceiling = availableCeilings[i];
            if (highestValue <= ceiling || i === availableCeilings.length - 1) {
                legendItems = new Array(5).fill(null).map((_: null, n) => {
                    const minValue = n === 0 ? 0 : ranges[i][n - 1];

                    const maxValue = n === colors.length - 1 ? Infinity : ranges[i][n];

                    let label = "";

                    switch (n) {
                        case 0:
                            label = `<${formatLabelValueThousands(ranges[i][n], lastCeiling)}`;
                            break;
                        case 1:
                        case 2:
                        case 3:
                            label = `${formatLabelValueThousands(minValue, lastCeiling)}-${formatLabelValueThousands(
                                maxValue,
                                lastCeiling
                            )}`;
                            break;
                        case 4:
                            label = `>${formatLabelValueThousands(maxValue, lastCeiling)}`;
                            break;
                    }

                    return [minValue, maxValue, label, colors[n]];
                });

                break;
            }
        }
    }

    return legendItems;
};
